<p-floatLabel variant="on" [ngClass]="{ 'invalid': isInvalid }">
    <p-datepicker [appendTo]="'body'" [iconDisplay]="'input'" [baseZIndex]="9999999999999" [showIcon]="true"
        dateFormat="dd/mm/yy" [disabled]="disabled || readOnly" (blur)="onTouched()" (onInput)="aplicarMascara($event)"
        (onSelect)="onCalendarChange($event)" [ngModel]="value" [readonlyInput]="readOnly" [minDate]="minDate ?? null"
        [maxDate]="maxDate ?? null" styleClass="calendar-full" [ngClass]="{ 'invalid': isInvalid }"></p-datepicker>
    <label>
        {{ label }}
    </label>
</p-floatLabel>
<div
    class="field-error"
    i7-field-error-message
    [control]="control"
    [fieldLabel]="label">
</div>
